<template>
  <div class="question-wrapper d-flex flex-column justify-content-between">
    <div class="question-header text-center">
      <h3>{{question.text}}</h3>
    </div>
    <div class="question-answers">
      <div class="question-answer text-center"
          v-for="(answer, index) in question.answers"
          :class="{'active': selectedAnswer && selectedAnswer.id === answer.id}"
          :key="index"
          @click="selectAnswer(answer)">
        <span>{{answer.text}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    question: {
      type: Object,
      required: true
    },
    selectedAnswer: {
      type: Object,
    }
  },
  methods: {
    selectAnswer: function (answer) {
      this.$emit('answerSelected', answer)
    }
  }
}
</script>

<style lang="scss" scoped>

.question-wrapper {
  min-height: 10rem;
}

.question-header {
  font-weight: bold;
  min-height: 5rem;
  margin-bottom:1rem;
  @media (max-width: 576px) {
    h3 {
      font-size: 1.5rem;
    }
  }
}

.question-answers {
  min-height: 12rem;
}

.question-answer.active {
  background-color:#d3d3d3;
}

.question-answer {
  cursor: pointer;
  padding: 0.5rem;
  font-size: 1.15rem;
  margin-left: 15%;
  margin-right: 15%;
}

@media screen and (max-width: 768px) {
  .question-answer {
    margin-left: 2.5%;
    margin-right: 2.5%;
  }
  .question-answer:focus,
  .question-answer:active {
    background-color:#d3d3d3;
  }
}

@media screen and (min-width: 768px) {
  .question-answer:hover {
    background-color:#d3d3d3;
  }
}

</style>